import React from "react";

/**
 * Logo variants:
 *  - dark (default in sidebar etc): orange gradient text WITHOUT black background
 *  - black: orange gradient on black plate (original brand) — only on dark heroes
 */
export function Logo({ size = "md", variant = "dark" }) {
  const sz = {
    sm: "text-base",
    md: "text-2xl",
    lg: "text-4xl",
    xl: "text-6xl",
  }[size];
  if (variant === "black") {
    const pad = { sm: "px-2 py-1", md: "px-3 py-1.5", lg: "px-4 py-2", xl: "px-6 py-3" }[size];
    return (
      <div className={`inline-flex items-center justify-center bg-black rounded-lg ${pad}`} data-testid="munners-logo">
        <span className={`${sz} font-display font-black tracking-tighter brand-gradient-text`}>MUNner's</span>
      </div>
    );
  }
  // dark (default) — clean text only, no black background
  return (
    <div className="inline-flex items-center" data-testid="munners-logo">
      <span className={`${sz} font-display font-black tracking-tighter brand-gradient-text leading-none`}>MUNner's</span>
    </div>
  );
}
